export default "__VITE_ASSET__BmATmAPO__"